import {
  Datagrid,
  DateField,
  EditButton,
  FunctionField,
  List,
  TextField,
  SearchInput,
  TextInput,
} from 'react-admin';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { CustomActions, IndexField } from '../../components';

const postFilters = [
  <SearchInput placeholder="Search by site name" source="site.name" alwaysOn />,
  <TextInput label="Name" source="name" />,
];

const ListCheckpoint = () => (
  <Card variant='elevation'>
    <CardContent>
      <Box>
        <Typography variant="h4">Manage Checkpoints</Typography>
        <List
          filters={postFilters}
          actions={<CustomActions addBtnLabel="Add Checkpoint" type="list" />}
        >
          <Datagrid rowClick="edit" size="medium" bulkActionButtons={false} sx={{ borderTop: '1px solid grey', maxHeight: '70vh', overflow: 'auto' }}>
            <FunctionField
              label='NO'
              render={(record) => <IndexField record={record} />}
            />
            <TextField label="NAME" source="name" sortable={false} />
            <TextField
              label="DESCRIPTION"
              source="description"
              sortable={false}
            />
            <TextField label="SITES" source="site.name" sortable={false} />
            <TextField label="CAMERAS" source="camera.name" sortable={false} />
            <DateField label='MODIFIED TIME' locales="en-SG"  source='updatedAt' showTime sortable={false} />
            <FunctionField
              label='ACTION'
              render={(record) => <EditButton label='' record={record} sx={{ color: 'white' }}/>}
            />
          </Datagrid>
        </List>
      </Box>
    </CardContent>
  </Card>
);

export default ListCheckpoint;
export { ListCheckpoint };